import {SHOW_ALERT} from '../actions/Alert';

const initialState = {
    show: false,
    state: 'info',
    message: null,
    dismissible: true,
    persistence: false,
    closeOnClick: true,
    readClicked: null
};

const AlertReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_ALERT:
            return {
                show: action.payload.show,
                state: action.payload.state,
                message: action.payload.message,
                dismissible: action.payload.dismissible,
                persistence: action.payload.persistence,
                closeOnClick: action.payload.closeOnClick,
                readClicked: action.payload.readClicked
            };
        default:
            return state;
    }
};


export default AlertReducer;
